import { ActivitiesQuantityPerStudent } from 'presentation/app/modules/Reports/pages/activities/quantitative/activities-quantity-per-student';

export const MakeActivitiesQuantityPerStudent: React.FC = () => {
  return <ActivitiesQuantityPerStudent />;
};
